import { render, staticRenderFns } from "./ProductContentChaptersAccordion.vue?vue&type=template&id=6ee98652&scoped=true&"
import script from "./ProductContentChaptersAccordion.vue?vue&type=script&lang=js&"
export * from "./ProductContentChaptersAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentChaptersAccordion.vue?vue&type=style&index=0&id=6ee98652&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee98652",
  null
  
)

export default component.exports